import * as ReactDOM from "react-dom";
import { ErrorPageGeneric } from "@discovery/components-dplus/lib/components/molecules/error-pages";
export const errorPage = (root) => ReactDOM.render(React.createElement(React.Fragment, null,
    React.createElement(ErrorPageGeneric, null),
    React.createElement("div", { style: {
            bottom: 0,
            left: 0,
            right: 0,
            position: "fixed",
        } }, "Unexpected client error")), root);
